import classNames from 'classnames';
import { Tooltip } from '@/shared/components/molecules/Tooltip';
import useSettingsStore from '@/shared/hooks/useSettingsStore';
import ClockIcon from '@/shared/icons/flip-ui-kit/small/Clock';
import TimeBoost from '@/shared/icons/flip-ui-kit/small/TimeBoost';
import type { RouteResponse } from '@/shared/integrations';
import { formatToApproxTime } from '@/shared/utils/date';

export const DurationBadge = ({ route }: { route: RouteResponse }) => {
  const isOnChainSwap = useSettingsStore((state) => state.isOnChainSwap);
  const isBoosted = route.integration === 'chainflip' && route.integrationData.isBoosted;
  const formattedDuration =
    route.durationSeconds > 0 ? formatToApproxTime(route.durationSeconds) : undefined;
  const formattedDefaultDuration =
    route.integration === 'chainflip' && route.integrationData.defaultDurationSeconds > 0
      ? formatToApproxTime(route.integrationData.defaultDurationSeconds)
      : undefined;

  const message = isOnChainSwap
    ? 'Estimated time to process your swap'
    : 'Estimated time to receive, process, and send your funds to the destination address';

  return (
    <div className={classNames('flex items-center font-aeonikMedium text-13 text-cf-light-3')}>
      <Tooltip content={message} link="https://docs.chainflip.io/protocol/swapping-basics">
        <div className="flex items-center gap-x-0.5 p-1">
          {isBoosted && !isOnChainSwap ? <TimeBoost className="text-cf-pink-1" /> : <ClockIcon />}
          <span>{formattedDuration}</span>
          {isBoosted && !isOnChainSwap && formattedDefaultDuration && (
            <span className="pl-0.5 text-12 text-cf-light-2 line-through">
              {formattedDefaultDuration}
            </span>
          )}
        </div>
      </Tooltip>
    </div>
  );
};
